export default __webpack_public_path__ + "static/media/Q32019.bc14b1d7.PDF";